import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { hash } from "../../../utils/hash";
import { SUPER_ADMIN_EMAIL, SUPER_ADMIN_HASHED_PASSWORD } from "../../../config/constants";

const SuperAdminSettingGuard = ({ children }) => {
  const { settingEmail, settingPassword } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const wasValid = useRef(false);

  useEffect(() => {
    async function check() {
      const valid =
        settingEmail === SUPER_ADMIN_EMAIL &&
        (await hash(settingPassword)) === SUPER_ADMIN_HASHED_PASSWORD;
      if (valid) {
        setChecked(true);
        wasValid.current = true;
      } else if (!wasValid.current) {
        navigate(-1);
      }
    }
    check();
  }, [settingEmail, settingPassword, navigate]);

  if (!checked) return null;
  return children;
};

export default SuperAdminSettingGuard;
